import React, { useRef, useState, useEffect, Fragment } from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from "./ModalContentWrapper";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import './ModalCompleteAudit.scss' ;
import { useForm } from "react-hook-form";
import { getProviderResponsesById, reopenSurvey, submitSurvey } from "root/DataFunctions/SectionFns";
import { AuditReviewStatus } from "root/DataFunctions/Constants";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";

export const ModalCompleteAuditMode = {
    SUBMIT : 'submit',
    REOPEN: 'reopen',
    ADHOC_REOPEN: 'adhoc_reopen',
};

const ModalCompleteAudit = ( { onClose, mode, provider_id, params } ) =>
{
    const [ generating, setGenerating ] = useState ( false );

    const survey_type = params.survey_type ;

    const { register, control, handleSubmit, setFocus, setValue, watch, formState: { errors: formErrors } } = useForm (
        {
            defaultValues: {
                comment: '',
            }
        } );

    useEffect(() => {
        if ( params.audit_review_status === AuditReviewStatus.IN_REVIEW )
        {
            // We are re-submitting to fetch the previous review status and comment
            getData();
        }
    }, []);

    const getData = () =>
    {
        getProviderResponsesById ( provider_id, params.provider_table_instance_id, ( response ) =>
        {
            const returnData = getDataFromResponse ( response );

            const rec = returnData[0] ;

            // Set the form values to the new values loaded from the database
            setValue ( 'comment',  rec.submission_summary ) ;

        })
    }

    const primaryButtonStyle = {
        marginRight: '0px',
        marginLeft: '10px'
    };

    const doSubmitSurvey = ( data, onComplete ) =>
    {
        setGenerating ( true );

        submitSurvey ( provider_id, 'current', survey_type,  data, ( response ) =>
        {
            setGenerating ( false );

            if ( onComplete !== null )
            {
                onClose ( 'saved' );
            }
        } )
    }

    const doReopenSurvey = ( is_adhoc ) =>
    {
        setGenerating ( true );

        reopenSurvey( provider_id, 'current', survey_type, is_adhoc, ( response ) =>
        {
            setGenerating ( false );

            onClose ( 'saved' );
        } )
    }

    const onClickGenerate = () =>
    {
        handleSubmit ( onSubmit ) ();
    }

    const onClickCancel = () =>
    {
        onClose ( 'cancel' );
    }

    const onSubmit = ( data ) =>
    {
        if ( mode === ModalCompleteAuditMode.SUBMIT )
        {
            doSubmitSurvey ( data );
        }
        else if ( mode === ModalCompleteAuditMode.REOPEN )
        {
            doReopenSurvey( false ) ;
        }
        else if ( mode === ModalCompleteAuditMode.ADHOC_REOPEN )
        {
            doReopenSurvey( true ) ;
        }
    }

    const generatingModeContent = () =>
    {
        return (
            <div style={ { textAlign: 'center', color: 'var(--vschool-mild-blue)', marginTop: '10px' } }>
                <h4>Processing...</h4>
                <h5 style={ { color: 'var(--vschool-mild-red)' } }>Please Wait - Do Not Refresh Your Screen</h5>
                <SpinnerDiv/>
            </div>
        )
    }

    const confirmReopenContent = () =>
    {
        return (
            <Fragment>
                <div className='buy-card-right'>
                    <p>You are about to re-open this survey for review.</p>
                    <p>Click the reopen button below to confirm.</p>

                    <form className='registration-form' onSubmit={ handleSubmit ( onSubmit ) }>
                        <div className='modal-button-row'>
                            <button type="button" onClick={ onClickCancel }
                                    className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/>
                            </button>
                            <button type="button" onClick={ onClickGenerate } style={ primaryButtonStyle }
                                    className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Re-Open<i className="et-check"/></button>
                        </div>
                    </form>
                </div>
            </Fragment>
        )
    }

    const submitSurveyContent = () =>
    {
        return (
            <Fragment>
                <div className='buy-card-right'>
                    <p>Add an optional summary comment or just click save to complete the audit for this provider. Your comment will be displayed
                        in the PDF report.</p>

                    <form className='registration-form' onSubmit={ handleSubmit ( onSubmit ) }>
                        <label>Summary Comment</label>
                        <textarea style={ { minHeight: '15em' } } className='form-control' id='comment' { ...register ( "comment" ) } />
                        {/*{ formErrors.document_title && <ErrorDiv>Please enter a document title</ErrorDiv>}*/ }


                        <div className='modal-button-row'>
                            <button type="button" onClick={ onClickCancel }
                                    className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/>
                            </button>
                            <button type="button" onClick={ onClickGenerate } style={ primaryButtonStyle }
                                    className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Save<i className="et-check"/></button>
                        </div>
                    </form>
                </div>
            </Fragment>
        )
    }
    const formContent = () =>
    {
        if ( generating )
        {
            return generatingModeContent() ;
        }
        else
        {
            if ( mode === ModalCompleteAuditMode.SUBMIT )
            {
                return submitSurveyContent() ;
            }
            else if ( mode === ModalCompleteAuditMode.REOPEN )
            {
                return confirmReopenContent() ;
            }
            else if ( mode === ModalCompleteAuditMode.ADHOC_REOPEN )
            {
                return confirmReopenContent() ;
            }
        }
    }

    const title = () =>
    {
        if ( mode === ModalCompleteAuditMode.SUBMIT )
        {
            return "Complete Audit";
        }
        else if ( mode === ModalCompleteAuditMode.REOPEN )
        {
            return "Re-Open Audit for Review";
        }
        else if ( mode === ModalCompleteAuditMode.ADHOC_REOPEN )
        {
            return "Re-Open Audit for Voluntary Review";
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <h3>{ title() }</h3>
            <div className='buy-card'>
                <div>
                    <span className='glyphicon glyphicon-file' style={ { color: 'var(--vschool-mild-blue)', fontSize: '15rem', marginTop: '30px' } }/>
                </div>
                { formContent () }
            </div>
        </ModalContentWrapper>
    )
}

export default ModalCompleteAudit;

ModalCompleteAudit.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};
